import { useQuery } from '@tanstack/react-query';
import { Group } from '../../../types';
import { useState } from 'react';
import { UserKeys, getUserGroupsUserPortal } from '../../api/users-api';
import { useUserSettings } from '../../utils/use-user-settings';
import { Messages } from '../../utils/message-constants';
import { Outlet, useParams } from 'react-router-dom';
import MyGroupsGrid from './my-groups-grid';

import Box from '@mui/material/Box';
import SharedTabHeader from '../../shared/shared-tab-header';

export default function MyGroupsPage() {
  const { loggedInUser } = useUserSettings();
  const { groupEmail } = useParams() as { groupEmail: string | undefined };

  const [paginationModel, setPaginationModel] = useState<{
    cursor: string | null;
    results: Group[];
    nameSpace: string;
    firstPull: boolean;
    searchTime: number;
    pageSize: number;
  }>({
    cursor: null,
    results: [],
    nameSpace: '',
    firstPull: true,
    searchTime: 0,
    pageSize: 100,
  });

  const {
    data: userPortalGroups,
    isLoading: userPortalGroupsLoading,
    isFetching: userPortalGroupsFetching,
  } = useQuery({
    queryKey: [UserKeys.UserGroups, paginationModel, loggedInUser],
    queryFn: () => getUserGroupsUserPortal(loggedInUser, paginationModel),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('your groups'),
    },
  });

  if (groupEmail) {
    return <Outlet />;
  }

  return (
    <Box
      sx={{
        p: 2,
        pt: 1,
      }}
    >
      <SharedTabHeader title="My Groups" noDivider />
      <Box
        sx={{ minHeight: 300, height: '62vh', width: '95%', mx: 'auto', mt: 1 }}
      >
        <MyGroupsGrid
          groups={userPortalGroups}
          groupsLoading={userPortalGroupsLoading}
          groupsFetching={userPortalGroupsFetching}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
        />
      </Box>
    </Box>
  );
}
